import { useContext } from 'react';

import { TaskDetailActionsContext } from './task-detail-context';

export const useOpenTaskStatistics = () => {
  const { openTaskStatistics } = useContext(TaskDetailActionsContext);

  return openTaskStatistics;
};
